import type { GetListingRequestsParams } from '../types/listingRequestsTypes'

export const listingRequestKeys = {
  // Own root key — listing requests are their own module, not a branch of the
  // property cache tree. Keeping them under `['property', …]` meant any
  // property mutation invalidating `propertyKeys.all` also nuked this tree.
  all: ['listingRequests'] as const,

  lists: () => [...listingRequestKeys.all, 'list'] as const,
  list: (filters: GetListingRequestsParams) => [...listingRequestKeys.lists(), filters] as const,

  details: () => [...listingRequestKeys.all, 'detail'] as const,
  detail: (id: string) => [...listingRequestKeys.details(), id] as const,

  // Nested UNDER `detail(id)` on purpose: every lifecycle mutation already
  // invalidates `detail(id)`, and TanStack matches by key prefix — so appending
  // an event to the log refreshes the Activity tab without a single mutation
  // needing to learn this key exists.
  timeline: (id: string) => [...listingRequestKeys.detail(id), 'timeline'] as const,

  // Nested under `detail(id)` for the same reason as `timeline`: proposing or
  // agreeing a price invalidates the detail, and the quote is priced off that
  // price — so it has to go stale with it.
  feeQuote: (id: string) => [...listingRequestKeys.detail(id), 'feeQuote'] as const,

  // Global per-status counts — one read feeds every sidebar badge and the
  // pipeline KPI row. Every lifecycle mutation invalidates this key.
  statusCounts: () => [...listingRequestKeys.all, 'statusCounts'] as const,
}
